import { render, staticRenderFns } from "./ExpenseSave.vue?vue&type=template&id=6809cb40&scoped=true"
import script from "./ExpenseSave.vue?vue&type=script&lang=js"
export * from "./ExpenseSave.vue?vue&type=script&lang=js"
import style0 from "./ExpenseSave.vue?vue&type=style&index=0&id=6809cb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809cb40",
  null
  
)

export default component.exports